import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UiNotificationItem } from "./UiNotificationItem";
import { SettingsIcon } from "../../../../../public/styles/img/svg/SettingsIcon";
import { UiTooltip } from "../../common/UiTolltip";
import { UiTooltipItem } from "../../common/UiTooltipItem";
import NotificationBell from "../../../../../public/styles/img/notification-blue-bell.png";
import MessageTick from "../../../../../public/styles/img/blue-message-tick.png";
import { UiNotificationView } from "./UiNotificationView";
import {
  clearNotificationDetailError,
  notificationDetailClear,
  notificationDetailRequest,
  notificationListRequest,
  notificationUnreadCountRequest,
  notificationUpdateRequest,
  setIsPaginatingNotifications,
} from "../../../../_redux/_actions";
import {
  commonConstants,
  inAppRouteMap,
  notificationConstants,
} from "../../../../_redux/_constants";
import { DateFormatterWithTimeOrAgo } from "../../../../_helpers/dateFormatter";
import { showCustomLoading } from "../../../../_helpers/support.services";
import { openSafeExternalUrl } from "../../../../_helpers/safeExternalUrl.helper";
import { UiGrayBgLoader } from "../../common/UiGrayBgLoader";
import { UiDashboardEmptyMessage } from "../../ErrorMessages/UiEmptyScreens";
import NotificationsEmpty from "../../../../../public/styles/img/notifications-empty.png";
import { UiPopup } from "../../common/UiModal";
import { ConfirmationPopup } from "../../Popups/ConfirmationPopup";
import { ConfirmationIcon } from "../../../../styles/img/svg/ConfirmationIcon";
import InfiniteScroll from "react-infinite-scroll-component";
import { SuccessPopup } from "../../Popups/SuccessMessagePopup";
import { SomethingWrongModal } from "../../Popups/SomethingWrongModal";

export const UiNotifications = (props) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [showViewNotification, setShowViewNotification] = useState(false);
  const [showNotificationNotAvailable, setShowNotificationNotAvailable] =
    useState(false);
  const [selectedDbId, setSelectedDbId] = useState(null);
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);
  const [showDeleteNotificationPopup, setShowDeleteNotificationPopup] =
    useState(false);
  const [notificationToDelete, setNotificationToDelete] = useState(null);

  const PAGE_SIZE = commonConstants.NOTIFICATION_LIST_PAGE_END || 12;
  const [pageStart, setPageStart] = useState(0);
  const [pageEnd, setPageEnd] = useState(PAGE_SIZE);
  const [showTooltip, setShowTooltip] = useState(false);

  const { loader } = useSelector((state) => ({ loader: state.loading }));
  const { notification } = useSelector((state) => ({
    notification: state.notification?.notificationList || [],
  }));

  const { notificationDetails } = useSelector((state) => ({
    notificationDetails: state.notification?.notificationDetails || {},
  }));

  const { notificationUpdate } = useSelector((state) => ({
    notificationUpdate: state.notification?.notificationUpdate || {},
  }));

  const { isNotificationDetailError } = useSelector((state) => ({
    isNotificationDetailError:
      state.notification?.isNotificationDetailError || false,
  }));

  const [showMissingLinkPopup, setShowMissingLinkPopup] = useState(false);
  const notificationWrapperRef = useRef(null);

  const fetchNotifications = (start, end) => {
    const payload = {
      locale: i18n.language,
      landingType: notificationConstants.NOTIFICATION_LANDING_TYPE,
      setToZero: notificationConstants.NOTIFICATION_SET_TO_ZERO,
      pageStart: start,
      pageEnd: end,
    };
    dispatch(notificationListRequest(payload));
  };

  useEffect(() => {
    fetchNotifications(pageStart, pageEnd);
  }, [i18n.language, pageStart, pageEnd, dispatch]);

  const notificationView = (item) => {
    const parsedData = JSON.parse(item.data || "{}");
    const selectedId = parsedData.notificationId || null;
    dispatch(
      notificationUpdateRequest({
        id: item.id,
        isRead: notificationConstants.NOTIFICATION_IS_READ_TRUE,
        isDeleted: notificationConstants.NOTIFICATION_IS_DELETED_FALSE,
      }),
    );
    if (
      item.notificationCategory ===
      notificationConstants.NOTIFICATION_LINK_TYPE_BIRTHDAY_REMINDER
    ) {
      return;
    }

    dispatch(
      notificationDetailRequest({
        locale: i18n.language,
        id: item.id,
        notificationId: selectedId,
      }),
    );

    setSelectedDbId(item?.id);
    setSelectedNotificationId(selectedId);
  };

  useEffect(() => {
    if (isNotificationDetailError) {
      setShowNotificationNotAvailable(true);
    }
  }, [isNotificationDetailError]);

  const handleCloseNotificationNotAvailableModal = () => {
    setShowNotificationNotAvailable(false);
    fetchNotifications(pageStart, pageEnd);
    dispatch(clearNotificationDetailError());
  };
  useEffect(() => {
    if (Object.keys(notificationDetails).length > 0) {
      let template = notificationDetails?.notificationTemplate;
      let linkType = template?.linkType?.name;
      let externalWebLink = template?.externalWebLink;
      let inAppSubRoute = template?.linkTypeSubCategory?.name;

      if (!template || !linkType) {
        setShowMissingLinkPopup(true);
      } else {
        if (
          linkType ===
          notificationConstants.NOTIFICATION_LINK_TYPE_EXTERNAL_WEB_LINK
        ) {
          if (externalWebLink) {
            openSafeExternalUrl(
              externalWebLink,
              notificationConstants.NOTIFICATION_DETAIL_NEW_TAB,
              { fallbackSameTab: true },
            );
          }
          const fetchPayload = {
            locale: i18n.language,
            landingType: notificationConstants.NOTIFICATION_LANDING_TYPE,
            setToZero: notificationConstants.NOTIFICATION_SET_TO_ZERO,
            pageStart: commonConstants.PAGE_START,
            pageEnd: commonConstants.NOTIFICATION_LIST_PAGE_END,
          };
          dispatch(notificationListRequest(fetchPayload));
        } else if (
          linkType ===
          notificationConstants.NOTIFICATION_LINK_TYPE_IN_APP_LOCATION
        ) {
          const targetPath = inAppRouteMap[inAppSubRoute];

          if (targetPath) {
            navigate(targetPath);
            props?.setShowNotification(false);
          }
          const fetchPayload = {
            locale: i18n.language,
            landingType: notificationConstants.NOTIFICATION_LANDING_TYPE,
            setToZero: notificationConstants.NOTIFICATION_SET_TO_ZERO,
            pageStart: commonConstants.PAGE_START,
            pageEnd: commonConstants.NOTIFICATION_LIST_PAGE_END,
          };
          dispatch(notificationListRequest(fetchPayload));
        } else if (
          linkType ===
          notificationConstants.NOTIFICATION_LINK_TYPE_NEW_DETAIL_SCREEN
        ) {
          setShowViewNotification(true);
        }
      }
    }
  }, [notificationDetails]);

  const notificationListView = () => setShowViewNotification(false);

  const truncateText = (text, limit) => {
    if (!text) return "";
    return text.length <= limit ? text : text.slice(0, limit).trim() + "...";
  };

  const handleMarkAllAsRead = () => {
    const updatePayload = {
      isRead: notificationConstants.NOTIFICATION_IS_READ_TRUE,
      isDeleted: notificationConstants.NOTIFICATION_IS_DELETED_FALSE,
      isAllMarkedAsRead: notificationConstants.NOTIFICATION_IS_MARK_ALL_AS_READ,
    };

    dispatch(notificationUpdateRequest(updatePayload));
    dispatch(setIsPaginatingNotifications(false));
  };

  useEffect(() => {
    if (notificationUpdate && Object.keys(notificationUpdate).length > 0) {
      fetchNotifications(pageStart, pageEnd);
      dispatch(notificationUnreadCountRequest({ locale: i18n.language }));
    }
  }, [notificationUpdate]);

  const handleDeleteClick = (id) => {
    setNotificationToDelete(id);
    setShowDeleteNotificationPopup(true);
  };

  const handleDeleteNotification = () => {
    if (!notificationToDelete) return;

    const payload = {
      id: notificationToDelete,
      isRead: notificationConstants.NOTIFICATION_IS_READ_TRUE,
      isDeleted: notificationConstants.NOTIFICATION_IS_DELETED_TRUE,
    };

    dispatch(notificationUpdateRequest(payload));
    dispatch(setIsPaginatingNotifications(false));

    setShowDeleteNotificationPopup(false);
    setNotificationToDelete(null);
  };

  const handleNotificationSettingsClick = () => {
    if (props?.setShowNotification) {
      props.setShowNotification(false);
    }
    navigate("/app/settings/notification-settings");
  };

  // Handle click outside to close notification popup
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Don't close notification panel if delete popup is open
      if (showDeleteNotificationPopup) {
        return;
      }

      // Check if click is on a modal/popup element
      const clickedElement = event.target;
      const isModalElement = clickedElement.closest('.MuiModal-root, .df-commmon-modal, .df-centerd-modal');
      if (isModalElement) {
        return;
      }

      if (
        notificationWrapperRef.current &&
        !notificationWrapperRef.current.contains(event.target) &&
        props?.setShowNotification &&
        typeof props?.setShowNotification === "function"
      ) {
        props.setShowNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowNotification, showDeleteNotificationPopup]);

  return (
    <>
      <div className="df-notifications-wrapper" ref={notificationWrapperRef}>
        {!showViewNotification && (
          <>
            <div className="df-notifications-wrapper__title">
              <h2>{t("Notifications")}</h2>

              <UiTooltip
                triggerIcon={<SettingsIcon />}
                className="df-settings-tooltip-notifications"
                isOpen={showTooltip}
                setIsOpen={setShowTooltip}
              >
                <UiTooltipItem
                  className="df-white-boxed-tooltip"
                  onClick={props?.deletehandler}
                >
                  <div
                    className="df-settings-tooltip-notifications__item"
                    onClick={handleNotificationSettingsClick}
                  >
                    <img src={NotificationBell} />
                    <span>{t("Notification Settings")}</span>
                  </div>
                  <div
                    className="df-settings-tooltip-notifications__item"
                    onClick={() => {
                      handleMarkAllAsRead();
                      setShowTooltip(false);
                    }}
                  >
                    <img src={MessageTick} />
                    <span>{t("Mark All As Read")}</span>
                  </div>
                </UiTooltipItem>
              </UiTooltip>
            </div>

            <div
              id="notification-scroll-container"
              className="df-notifications-wrapper__body"
            >
              {notification && notification.length === 0 ? (
                showCustomLoading(
                  [notificationConstants.NOTIFICATION_LIST_REQUEST],
                  loader?.pendingRequests,
                ) ? (
                  <UiGrayBgLoader className="df-ch-130" />
                ) : (
                  <UiDashboardEmptyMessage
                    icon={NotificationsEmpty}
                    className="df-fs-empt df-empt-msg-acc"
                  >
                    <h3>
                      {t("Uh-oh!")} <br />
                      {t("No notifications to display")}
                    </h3>
                    <p>
                      {t(
                        "There are no notifications at the moment. Check back later for updates.",
                      )}
                    </p>
                  </UiDashboardEmptyMessage>
                )
              ) : (
                notification &&
                notification.length > 0 && (
                  <InfiniteScroll
                    dataLength={notification.length}
                    next={() => {
                      let nextStart = pageEnd + 1;
                      let nextEnd = pageEnd + 12;
                      setPageStart(nextStart);
                      setPageEnd(nextEnd);
                      dispatch(setIsPaginatingNotifications(true));
                    }}
                    hasMore={!notification.isEmpty}
                    scrollableTarget="notification-scroll-container"
                    loader={<h3 className="text-center"></h3>}
                    endMessage={
                      <p className="text-center">
                        {t("No more notifications")}
                      </p>
                    }
                  >
                    {notification.map((item) => (
                      <UiNotificationItem
                        key={item?.id}
                        icon={
                          item?.notificationCategoryImage &&
                          process.env.NFS_PUBLIC_IMAGE_URL +
                            process.env.PUBLIC_STATIC_IMAGE_URL +
                            "/images/notification_category_images/" +
                            item?.notificationCategoryImage
                        }
                        message={truncateText(item.body)}
                        date={DateFormatterWithTimeOrAgo(item?.date)}
                        onClick={() => notificationView(item)}
                        status={
                          item.isRead ===
                          notificationConstants.NOTIFICATION_IS_READ_TRUE
                            ? notificationConstants.NOTIFICATION_READ
                            : notificationConstants.NOTIFICATION_UNREAD
                        }
                        deletehandler={() => handleDeleteClick(item.id)}
                      />
                    ))}
                  </InfiniteScroll>
                )
              )}
            </div>
          </>
        )}

        {showViewNotification && (
          <UiNotificationView
            showNotification={props?.setShowNotification}
            onClick={notificationListView}
            id={selectedDbId}
            selectedId={selectedNotificationId}
          />
        )}
      </div>

      <UiPopup
        openModal={showDeleteNotificationPopup}
        handleClose={() => setShowDeleteNotificationPopup(false)}
      >
        <ConfirmationPopup
          icon={<ConfirmationIcon />}
          message={t("Delete Notification")}
          buttonOnClick={handleDeleteNotification}
          buttonOnClickName={t("Delete")}
          className="df-confirmation-message-popup df-btn-grpdmodal"
          buttonOnClickClose={() => setShowDeleteNotificationPopup(false)}
        >
          <p>{t("Are you sure you want to delete this notification?")}</p>
        </ConfirmationPopup>
      </UiPopup>

      <UiPopup
        openModal={showMissingLinkPopup}
        handleClose={() => setShowMissingLinkPopup(false)}
      >
        <SuccessPopup
          message={notificationDetails?.notificationTemplate?.notificationTitle}
          className="df-confirmation-message-popup df-success-message-conf"
          buttonText={t("Ok")}
          buttonOnClick={() => {
            setShowMissingLinkPopup(false);
            dispatch(notificationDetailClear());
            const fetchPayload = {
              locale: i18n.language,
              landingType: notificationConstants.NOTIFICATION_LANDING_TYPE,
              setToZero: notificationConstants.NOTIFICATION_SET_TO_ZERO,
              pageStart: commonConstants.PAGE_START,
              pageEnd: commonConstants.NOTIFICATION_LIST_PAGE_END,
            };

            dispatch(notificationListRequest(fetchPayload));
          }}
        >
          <p className="mb-1">
            {notificationDetails?.notificationTemplate?.notificationMessage}
          </p>
        </SuccessPopup>
      </UiPopup>

      <UiPopup
        openModal={showNotificationNotAvailable}
        handleClose={handleCloseNotificationNotAvailableModal}
      >
        <SomethingWrongModal
          icon={<ConfirmationIcon />}
          message={t("Notification Unavailable")}
          buttonText={t("Ok")}
          buttonOnClick={handleCloseNotificationNotAvailableModal}
          className="df-confirmation-message-popup df-btn-grpdmodal"
          buttonClass="df-ui-dark-bg-btn df-w-90-btn"
        >
          <p className="mb-1">
            {t(
              "The notification you’re trying to access is no longer available.",
            )}
          </p>
        </SomethingWrongModal>
      </UiPopup>
    </>
  );
};
